import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout1.component.html'
  ,styleUrls:['./default-layout1.component.scss']
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  wrapperClass="";//toggled



  constructor(
    private router: Router
  ) {

  }

  ngOnInit() {

  }

  onToggleEvent($event){
    if (this.sidebarMinimized==true){
      this.wrapperClass="";
    }else{
      this.wrapperClass="wrapper-toggled";
    }

    this.sidebarMinimized=!this.sidebarMinimized;

  }

}
